import React, { useState } from 'react';
import { IntercomEvents } from '../../enums/intercom-events';
import { Cross, MessageCircle } from '../../svg';
import { AuthHelper } from '../../utils';
import { shouldHideIntercom } from '../../utils/user-details';

const HelpscoutButton = ({ showLabel = false }) => {
  const [isHelpscoutBeaconOpen, setIsHelpscoutBeaconOpen] = useState(false);

  if (shouldHideIntercom()) {
    return null;
  }

  const intercomHelperFunction = () => {
    if (window.Intercom && !isHelpscoutBeaconOpen) {
      window.Intercom(IntercomEvents.SHOW, IntercomEvents.ON_SHOW, () => {
        setIsHelpscoutBeaconOpen(true);
      });
    }
    if (window.Intercom && isHelpscoutBeaconOpen) {
      window.Intercom(IntercomEvents.HIDE, IntercomEvents.ON_HIDE, () => {
        setIsHelpscoutBeaconOpen(false);
      });
    }
  };

  const onIntercomScoutToggle = () => {
    setIsHelpscoutBeaconOpen(!isHelpscoutBeaconOpen);
    intercomHelperFunction();
  };

  if (window.Intercom) {
    window.Intercom(IntercomEvents.ON_SHOW, () => {
      setIsHelpscoutBeaconOpen(true);
    });
    window.Intercom(IntercomEvents.ON_HIDE, () => {
      setIsHelpscoutBeaconOpen(false);
    });
  }

  return (
    <button
      type="button"
      className={`helpscout-button ${
        !AuthHelper.isAuthenticated && 'helpscout-logout'
      } ${showLabel ? 'showLabel' : ''}`}
      onClick={onIntercomScoutToggle}
    >
      <div className="helpscout-button-icon">
        {isHelpscoutBeaconOpen ? <Cross /> : <MessageCircle />}
      </div>
      {showLabel && <span>Chat with us</span>}
    </button>
  );
};

export default HelpscoutButton;
